import React from "react";
import "./Hero.css";

// Background image (keep your existing photo)
import heroImage from "../assets/heronew.jpeg";

// TEMP: sample logo — replace with your actual file when you have it
import logo from "../assets/Renewed Life Professional Networking Logo No Background.webp";

const Hero = () => {
  return (
    <section className="hero" aria-label="Renewed Life Networking Group">
      {/* Background Image + Overlay */}
      <div className="hero-background" aria-hidden="true">
        <img src={heroImage} alt="" />
        <div className="hero-overlay" />
      </div>

      {/* Centered Content */}
      <div className="hero-container">
        <div className="hero-center">
          <img
            src={logo}
            alt="Renewed Life Networking Group logo"
            className="hero-logo"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
